// import * as fJS from './cjsRoot/fJS';
import createjs from 'createjs-collection';

import { cjsStage } from '__mainSrcDir/components/TrGame/v4/mixins/cjsStage';
import { cjsGroup } from '__mainSrcDir/components/TrGame/v4/mixins/cjsRoot/cjsGroup';
import { cjsItem } from '__mainSrcDir/components/TrGame/v4/mixins/cjsRoot/cjsBase';

export class preStage extends cjsStage {
  _configGroups;

  constructor(initData, mixin) {
    super(initData, mixin);

    this._stage.mouseMoveOutside = true;
    this.groups = {};
    console.log(this);
  }

  _setStage() {
    console.log('SET STAGE');
    this._setOffsetStage();
  }
  _loadStage() {
    console.log('LOAD STAGE');
  }

  reRunTicker() {
    this._ticker = createjs.Ticker;
    this.ticker.timingMode = createjs.Ticker.RAF;
    this.ticker.framerate = this.defConfig.framerate;
    if (this.ticker.hasEventListener('tick')) this.ticker.removeAllEventListeners();
    this.ticker.addEventListener(
      'tick',
      function (self, e) {
        self.tick(e);
      }.bind({}, this)
    );
  }

  tick(e) {
    this.stage.update(e);
  }

  findContainerStage(id) {
    for (let i in this.stage.children) {
      if (this.stage.children[i].name == id) return this.stage.children[i];
    }
    return -1;
  }

  groupMouseDown(e) {
    this.groups[e.currentTarget.name]._mouseLocal = { x: e.localX, y: e.localY };
    e.stopPropagation();
  }

  groupPressMove(e) {
    let point = this.stage.globalToLocal(e.stageX, e.stageY);
    let stop = { x: false, y: false };
    if (point.x + this._offset.x - Math.abs(this.groups[e.currentTarget.name]._mouseLocal.x) < 0) {
      this.groups[e.currentTarget.name]._posConfig.x = 0;
      this.groups[e.currentTarget.name].x = -this._offset.x;
      this.groups[e.currentTarget.name].pos.x = 0;
      stop.x = true;
    }
    if (point.y + this._offset.y - Math.abs(this.groups[e.currentTarget.name]._mouseLocal.y) < 0) {
      this.groups[e.currentTarget.name]._posConfig.y = 0;
      this.groups[e.currentTarget.name].y = -this._offset.y;
      this.groups[e.currentTarget.name].pos.y = 0;
      stop.y = true;
    }

    if (!stop.x) {
      this.groups[e.currentTarget.name].x = point.x - Math.abs(this.groups[e.currentTarget.name]._mouseLocal.x);
      this.groups[e.currentTarget.name].pos.x = point.x;
      this.groups[e.currentTarget.name]._posConfig.x =
        this.groups[e.currentTarget.name].pos.x +
        this._offset.x -
        Math.abs(this.groups[e.currentTarget.name]._mouseLocal.x);
    }
    if (!stop.y) {
      this.groups[e.currentTarget.name].y = point.y - Math.abs(this.groups[e.currentTarget.name]._mouseLocal.y);
      this.groups[e.currentTarget.name].pos.y = point.y;
      this.groups[e.currentTarget.name]._posConfig.y =
        this.groups[e.currentTarget.name].pos.y +
        this._offset.y -
        Math.abs(this.groups[e.currentTarget.name]._mouseLocal.y);
    }
  }

  addItem(obj) {
    this.groups[obj.idGroup]._items[obj.id] = new cjsItem({
      idGroup: obj.idGroup,
      id: obj.id,
      correct: [],
      stage: this,
      block: true,
    });

    console.log(obj);

    // this.groups[obj.idGroup]._items[obj.id]

    this.groups[obj.idGroup]._items[obj.id]._layout.background = obj.itemsConfig.background;
    this.groups[obj.idGroup]._items[obj.id]._layout.positions = obj.itemsConfig.positions;
    this.groups[obj.idGroup]._items[obj.id].create();

    console.log(this.groups[obj.idGroup]._items[obj.id]);

    this.groups[obj.idGroup].container.addChild(this.groups[obj.idGroup]._items[obj.id].container);
  }

  addGroup(gr) {
    this.groups[gr.idGroup] = new cjsGroup({
      id: gr.idGroup,
      block: true,
      sort: false,
      shuffle: true,
      stage: this,
    });

    this.groups[gr.idGroup]._layout.background = gr.background;
    this.groups[gr.idGroup].create();
    this.groups[gr.idGroup].container.on('mousedown', this.groupMouseDown, this);
    this.groups[gr.idGroup].container.on('pressmove', this.groupPressMove, this);
    this.groups[gr.idGroup]._mouseLocal = false;
    this.groups[gr.idGroup]._posConfig = { x: 0, y: 0 };
    this.groups[gr.idGroup].posStart = _.cloneDeep(this.groups[gr.idGroup].pos);

    this.stage.addChild(this.groups[gr.idGroup].container);
  }

  updateGroup(gr) {
    console.log('UPDATE GROUP PRESTAGE: ' + gr.idGroup);
    console.log(gr);
    let container = this.findContainerStage(gr.idGroup);
    if (container == -1) {
      // this.beforeDestroy();
      // throw 'Nie ma na scenie conteneru o id: ' + gr.id;
      console.log('Nie ma na scenie conteneru o id: ' + gr.idGroup);
      return;
    }
    let width = Math.sign(gr.positions.pos.width) == 1 ? gr.positions.pos.width : 0,
      height = Math.sign(gr.positions.pos.height) == 1 ? gr.positions.pos.height : 0;

    if (Math.sign(gr.positions.pos.x) == 1 && Math.sign(gr.positions.pos.y) == 1) {
      this.groups[gr.idGroup].x = gr.positions.pos.x - this._offset.x;
      this.groups[gr.idGroup].y = gr.positions.pos.y - this._offset.y;
    } else if (
      Math.sign(gr.positions.pos.x) != 1 &&
      Math.sign(gr.positions.pos.y) != 1 &&
      gr.positions.type == 'absolute'
    ) {
      gr.positions.pos.x = 0;
      gr.positions.pos.y = 0;
      this.groups[gr.idGroup].x = gr.positions.pos.x - this._offset.x;
      this.groups[gr.idGroup].y = gr.positions.pos.y - this._offset.y;
    } else {
      console.log(this.configGroups);
      this.groups[gr.idGroup].x = 0;
      this.groups[gr.idGroup].y = 0;
      for (let i = 0; i < this.configGroups.length; i++) {
        if (this.configGroups[i].idGroup == gr.idGroup) {
          break;
        }
        if (this.configGroups[i].positions.type == 'absolute') {
          continue;
        }
        this.groups[gr.idGroup].x +=
          this.groups[this.configGroups[i].idGroup].x +
          this.groups[this.configGroups[i].idGroup].container.width +
          this._offset.x;
        this.groups[gr.idGroup].y =
          this.groups[this.configGroups[i].idGroup].y +
          // this.groups[this.configGroups[i].idGroup].container.height +
          this._offset.y;
      }
      this.groups[gr.idGroup].x -= this._offset.x;
      this.groups[gr.idGroup].y -= this._offset.y;
    }

    if (width == 0 || height == 0) {
      for (let i in container.children) {
        if (container.children[i] instanceof createjs.Container) {
          console.log(container.children[i].name);
          if (
            container.children[i].x + container.children[i].width > container.width &&
            Math.sign(gr.positions.pos.width) != 1
          ) {
            width = container.children[i].x + container.children[i].width;
          }
          if (
            container.children[i].y + container.children[i].height > container.height &&
            Math.sign(gr.positions.pos.height) != 1
          ) {
            height = container.children[i].y + container.children[i].height;
          }
        }
      }
    }
    if (
      gr.positions.autoFit == false &&
      Math.sign(gr.positions.pos.width) != 1 &&
      Math.sign(gr.positions.pos.height) != 1
    ) {
      gr.positions.pos.width = width;
      gr.positions.pos.height = height;
    }

    this.groups[gr.idGroup]._redrawShape(container, gr.background, {
      width: width,
      height: height,
      x: this.groups[gr.idGroup].posStart.x,
      y: this.groups[gr.idGroup].posStart.y,
    });

    console.log('W: ' + width + ' - H: ' + height);
  }

  addImageBgr(preview, container, image) {
    let divImg = document.createElement('img');
    divImg.setAttribute('src', preview.src);
    let source = new createjs.Bitmap(divImg);
    if (Math.sign(image.pos.width) == 1) {
      source.scaleX = image.pos.width / source.getBounds().width;
    }
    if (Math.sign(image.pos.height) == 1) {
      source.scaleY = image.pos.height / source.getBounds().height;
    }

    let exists = -1;
    for (let i in container.children) {
      if (container.children[i] instanceof createjs.Bitmap) {
        exists = i;
      }
    }
    if (exists == -1) {
      container.addChild(source);
    } else {
      container.children[exists] = source;
    }
  }

  removeImageBgr(container) {
    let exists = -1;
    for (let i in container.children) {
      if (container.children[i] instanceof createjs.Bitmap) {
        exists = i;
      }
    }

    if (exists != -1) {
      container.removeChildAt(exists);
    }
  }

  removeGroup(idGroup) {
    let child = -1;
    for (let i in this._stage.children) {
      console.log(i + ' ' + this._stage.children[i].name);
      if (this._stage.children[i].name == idGroup) {
        child = i;
        break;
      }
    }
    if (child > -1) {
      this._stage.removeChildAt(child);
      delete this.groups[idGroup];
    }
  }

  updateImageBgr(container, pos) {
    let exists = -1;
    for (let i in container.children) {
      if (container.children[i] instanceof createjs.Bitmap) {
        exists = i;
      }
    }

    if (exists != -1) {
      let image = container.children[exists];
      image.x = pos.x;
      image.y = pos.y;
      image.scaleX = pos.width / image.getBounds().width;
      image.scaleY = pos.height / image.getBounds().height;
    }
  }

  set configGroups(val) {
    this._configGroups = val;
  }
  get configGroups() {
    return this._configGroups;
  }
}
